import { render, staticRenderFns } from "./Repayments.vue?vue&type=template&id=c733258e&scoped=true&"
import script from "./Repayments.vue?vue&type=script&lang=js&"
export * from "./Repayments.vue?vue&type=script&lang=js&"
import style0 from "./Repayments.vue?vue&type=style&index=0&id=c733258e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c733258e",
  null
  
)

export default component.exports